import { render, staticRenderFns } from "./DriverTicketList.vue?vue&type=template&id=2c8146bb&scoped=true&"
import script from "./DriverTicketList.vue?vue&type=script&lang=js&"
export * from "./DriverTicketList.vue?vue&type=script&lang=js&"
import style0 from "./DriverTicketList.vue?vue&type=style&index=0&id=2c8146bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8146bb",
  null
  
)

export default component.exports